'use client'

import { useState, useEffect } from 'react'
import { usePlotStore } from '../../../../stores/plotStore'
import { PlotEditor } from './PlotEditor'
import { Alert, AlertDescription, Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@creanizer/ui'
import type { SavedPlot } from '@creanizer/types'

interface EditModeContainerProps {
  initialPlotId?: string | null
  onClose: () => void
}

export function EditModeContainer({ initialPlotId, onClose }: EditModeContainerProps) {
  const { savedPlots } = usePlotStore()
  const [selectedPlotId, setSelectedPlotId] = useState<string | null>(initialPlotId || null)
  
  // デバッグログ
  useEffect(() => {
    console.log('[EditModeContainer] mounted/updated with:', {
      initialPlotId,
      selectedPlotId,
      savedPlotsLength: savedPlots.length,
      savedPlotsIds: savedPlots.map(p => p.id)
    })
  })

  // 初回表示時または保存済みプロットが変更された時の処理
  useEffect(() => {
    console.log('[EditModeContainer] savedPlots effect triggered')
    if (!selectedPlotId && savedPlots.length > 0) {
      setSelectedPlotId(savedPlots[0].id)
    } else if (selectedPlotId && !savedPlots.find(p => p.id === selectedPlotId)) {
      // 選択中のプロットが削除された場合
      setSelectedPlotId(savedPlots[0]?.id || null)
    }
  }, [savedPlots, selectedPlotId])

  if (savedPlots.length === 0) {
    return (
      <Alert>
        <AlertDescription>
          保存されたプロットがありません。まずプロットを生成して保存してください。
        </AlertDescription>
      </Alert>
    )
  }

  const selectedPlot = savedPlots.find(p => p.id === selectedPlotId)
  if (!selectedPlot) {
    return (
      <Alert>
        <AlertDescription>
          プロットの読み込み中...
        </AlertDescription>
      </Alert>
    )
  }

  return (
    <div className="space-y-4">
      {/* プロット選択 */}
      <div className="space-y-2">
        <Label>編集するプロットを選択</Label>
        <Select
          value={selectedPlotId || ''}
          onValueChange={(value) => {
            setSelectedPlotId(value)
          }}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {savedPlots.map((plot) => (
              <SelectItem key={plot.id} value={plot.id}>
                {plot.title} ({new Date(plot.createdAt).toLocaleDateString('ja-JP')})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      {/* PlotEditorコンポーネント */}
      <PlotEditor 
        key={selectedPlotId}
        plot={selectedPlot} 
        onClose={onClose}
      />
    </div>
  )
}